import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp, {BLACK} from 'src/components/Stamp/Stamp';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
};

const ScholarshipsNotYetAvailableText = ({showTooltipFlag = false}) => {
  const infoText = 'Micro-scholarships not yet available';
  if (!showTooltipFlag) {
    return (
      <div className="college-earnings-no-earnings-status-text-content">
        <Stamp>{infoText}</Stamp>
      </div>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={BLACK} className="flag">
            <Icon iconType="flag" color="grey" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

ScholarshipsNotYetAvailableText.propTypes = propTypes;

export default ScholarshipsNotYetAvailableText;
